<template>
  <div class="container-fluid">
    <div class="row pt-4">
      <div class="col-8">
        <p class="page-title">
          <i class="fas fa-newspaper"></i> Pages
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <GridTable :data="gridData" :columns="gridColumns" :filter-key="searchQuery" />
        <b-pagination
          size="sm"
          v-model="page"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BPagination } from 'bootstrap-vue';
import { GridTable } from '@dmunoz/gridtable';

import DomainApiRequest from '@/components/ApiRequester/Domain.js';

export default {
  name: 'Series',
  components: {
    GridTable,
    BPagination,
  },
  data() {
    return {
      searchQuery: '',
      totalRows: 0,
      page: 1,
      gridData: [],
      gridColumns: [
        {
          column: 'Name',
          index: 'name',
          type: 'link',
          path: '/page/:id/media/:smallbanner'
        },
        {
          column: 'URL',
          index: 'url',
          type: 'raw',
        },
      ],
    };
  },
  computed: {
    perPage: () => 100
  },
  mounted() {
    document.getElementById('loader').classList.add('active');
    this.fetchPages().then((response => {
      const { total, data } =  response;
      data.forEach((item) => {
        this.gridData.push(Object.assign(item, {'smallbanner': false}));
          let cnt = 0;
          item.media.forEach((media) => {
            if (media.media_groups_id > 1) {
              cnt++;
            }
        });
        if (cnt > 0 || item.name === "Home") {
          this.gridData.push({'id': item.id, 'name': item.name + ' small banner','url': item.url, 'smallbanner': true});
        }
      });
      this.totalRows = total;
      document.getElementById('loader').classList.remove('active');
    })).catch(() => {
      document.getElementById('loader').classList.remove('active');
    });
  },
  methods: {
    fetchPages() {
      const ApiRequest = new DomainApiRequest();
      return ApiRequest.detail({
        domain_id: this.$route.params.id
      }).then((response) => response.data);
    },
  },
};
</script>
